export default "__VITE_ASSET__DRI8rHNp__"